import { computed, type Ref, ref } from 'vue'

function usePagination(totalItems: Ref<number>) {
  const itemsPerPage = ref<number>(10)
  const totalPages = computed(() => Math.ceil(totalItems.value / itemsPerPage.value))
  const currentPage = ref<number>(1)

  function nextPage() {
    if (currentPage.value < totalPages.value) {
      currentPage.value++
    }
  }

  function prevPage() {
    if (currentPage.value > 1) {
      currentPage.value--
    }
  }

  function setCurrentPage(page: number) {
    const maxPage = totalPages.value || 1
    const minPage = 1

    const minLimitedPage = Math.max(page, minPage)
    currentPage.value = Math.min(minLimitedPage, maxPage)
  }

  function setItemsPerPage(value: number) {
    itemsPerPage.value = Math.max(1, value)
  }

  return {
    itemsPerPage,
    currentPage,
    totalPages,
    nextPage,
    prevPage,
    setItemsPerPage,
    setCurrentPage
  }
}

export default usePagination
